import React, { useEffect } from 'react';
import Table from '../../table/Table';
import text from '../../../text';
import ProductRow from './ProductRow';
var newProduct = {
    productKey: ''
};
var UpdateProductTable = function(props) {
    var products = props.products, productsHelpers = props.productsHelpers, initialProducts = props.initialProducts;
    useEffect(function() {
        if (products.length === 0) {
            productsHelpers.push(newProduct);
        }
    }, [
        products
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        className: "UpdateProductTable"
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("th", null, text('product')), /*#__PURE__*/ React.createElement("th", null, text('status')), /*#__PURE__*/ React.createElement("th", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, text('estimatedTimeOfArrival')))), /*#__PURE__*/ React.createElement("tbody", null, products && products.map(function(product, i) {
        return /*#__PURE__*/ React.createElement(ProductRow, {
            name: "detailedStatus.".concat(i),
            initialProducts: initialProducts,
            products: products,
            key: i,
            product: product
        });
    })));
};
export default UpdateProductTable;
